import { useState } from "react";
import * as React from "react";
import {
  faCheckSquare,
  faPalette,
  faTrash,
  faFolderPlus,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { colors } from "../App";
import { Mode } from "./ToDoList";
import { ListSelect } from "./ListSelect";

const url = "https://bounch.web.app/";

export const Toolbox = (props: {
  setMode: (mode: Mode) => void;
  mode: Mode;
}) => {
  return (
    <div className="toolbar">
      <button
        id="normal"
        className="tool"
        onClick={() => {
          props.setMode(Mode.Normal);
          console.log(Mode.Normal);
        }}
        style={{
          backgroundColor: props.mode === Mode.Normal ? colors[5] : "#FFFFFF00",
          color: props.mode === Mode.Normal ? "#FFFFFF" : colors[0],
        }}
      >
        <FontAwesomeIcon icon={faCheckSquare} fixedWidth />
      </button>
      <button
        id="fill"
        className="tool"
        onClick={() => {
          props.setMode(Mode.Fill);
        }}
        style={{
          backgroundColor:
            props.mode === Mode.Fill
              ? colors[5]
              : //? `${itemColors[selectedColor]}`
                "#FFFFFF",
          color: props.mode === Mode.Fill ? "#FFFFFF" : colors[0],
        }}
      >
        <FontAwesomeIcon icon={faPalette} fixedWidth />
      </button>
      <button
        className="tool"
        id="delete"
        onClick={() => {
          props.setMode(Mode.Delete);
        }}
        style={{
          backgroundColor: props.mode === Mode.Delete ? colors[5] : "#FFFFFF",
          color: props.mode === Mode.Delete ? "#FFFFFF" : colors[0],
        }}
      >
        <FontAwesomeIcon icon={faTrash} fixedWidth />
      </button>
      <button
        id="newList"
        className="tool"
        onClick={() =>
          window.open(
            `${window.location.protocol}//${window.location.host}`,
            "_blank"
          )
        }
        style={{ backgroundColor: "transparent" }}
      >
        <FontAwesomeIcon icon={faFolderPlus} fixedWidth />
      </button>
      <button
        className="tool"
        onClick={() => navigator.clipboard.writeText(window.location.href)}
        style={{ backgroundColor: "transparent" }}
      >
        <FontAwesomeIcon icon={faCopy} fixedWidth />
      </button>
    </div>
  );
};
